import React, { useEffect, useState } from 'react'
import { getDeviceSize } from '../../exports/InteractiveUtils';
import { numberFormat, priceFormat } from '../../exports/UtilFunctions';

const DEVICE_SIZE = getDeviceSize();

const FamilyPortfolioTable = ({transaction}) => {
    const [transactions,setTransaction] = useState([])

    useEffect(()=>{
        setTransaction(transaction.slice(0,-1))
    },[])
    return (
        <div className="family-stocks-table">
            {!transactions || transactions.length === 0 ? (
                <></>
            ) : (
                <>
                    {DEVICE_SIZE === "S" ? (
                        <>
                    {transaction.slice(0, -1).map((h, index) => {
                      return (
                        <PortfolioCard
                          key={index}
                          data={h}
                        //   handleBuy={handleBuy}
                        //   handleSell={handleSell}
                        />
                      );
                    })}
                        </>
                    ) : (
                        <>
                            <table className='family-mf-table'>
                                <thead>
                                    <tr>
                                        <td className="scheme-name">Scheme Name</td>
                                        <td className="">Folio No</td>
                                        <td className="">Units</td>
                                        {/* <td className="inv-cost">Inv. Cost (Avg. Cost)</td> */}
                                        <td className="inv-value">Inv. Value (Curr. Nav)</td>
                                        <td className="profit-loss">Profit/ Loss</td>
                                        <td className="">Weight</td>
                                        <td className="">Tot. Ret./XIRR</td>
                                        {/* <td className="">XIRR</td> */}
                                        <td>Change</td>
                                        <td className="hover-td"></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {transactions.map((h, index) => {
                                        const isTotalRow = h.scheme_name === "TOTAL";
                                        return (
                                            <tr key={index} className={isTotalRow ? "total-row" : "yes_hover"}>
                                                <td className="body-scheme-name">{isTotalRow ? "" : h.scheme_name}</td>
                                                <td>{isTotalRow ? "" : h.folio_no}</td>
                                                <td>{isTotalRow ? "" : numberFormat(h.units)}</td>
                                                <td className={isTotalRow ? "total-col" : ""}>
                                                    {priceFormat(h.investment_value)} {isTotalRow ? "" : `(${priceFormat(h.current_nav)})`}<br />
                                                    <span style={{ fontSize: "10px" }}>
                                                        {priceFormat(h.investment_cost)} {isTotalRow ? "" : `(${priceFormat(h.avg_cost)})`}
                                                    </span>
                                                </td>
                                                {/* <td className={isTotalRow ? "total-col" : ""}>
                                                                   {priceFormat(h.investment_value)} {isTotalRow ? "" : `(${priceFormat(h.current_nav)})`}
                                                                 </td> */}
                                                <td className={isTotalRow ? "total-col" : ""}>{priceFormat(h.profit_loss)}</td>
                                                <td className={isTotalRow ? "total-col" : ""}>{numberFormat(h.weight)}%</td>
                                                <td className={`${h.total_return >= 0 ? "positive" : "negative"} ${isTotalRow ? "total-col" : ""}`}>
                                                    {numberFormat(h.total_return)}%<br />
                                                    {numberFormat(h.xirr)}%
                                                </td>
                                
                                                <td className={h.navChange >= 0 ? "positive" : "negative"}>
                                                    {isTotalRow ? "" : `${numberFormat(h.navChange) + "%" || "--"}`}
                                                </td>

                                                {/* {!isTotalRow && (
                                                                   <div className="hover-container">
                                                                     <div
                                                                       className="hover-btn hover-input-btn"
                                                                       onClick={() => handleFirstDate(account_token,h.isin,h.folio_no)}
                                                                     >
                                                                       <img
                                                                         src="/static/media/select-graph.4c225a2b.svg"
                                                                         alt="hoverbutton"
                                                                         width="20px"
                                                                         height="10px"
                                                                       />
                                                                     </div>
                                                                   </div>
                                                                 )} */}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </>
                    )}
                </>
            )}
        </div>
    )
}

function PortfolioCard({ data, handleBuy, handleSell }) {
  const {
    folio_no,
    current_nav,
    navChange,
    category,
    scheme_name,
    investment_cost,
    avg_cost,
    investment_value,
    profit_loss,
    units,
    Weight,
    xirr,
    total_return,
  } = data;

  return (
    <div className="mf-watchlist-card">
      <div className="mfwc-info">
        <div className="isin-price">
          <p className="isin-type">
            Folio:&nbsp;<span>{folio_no}</span>
          </p>
          <p className="price-change">
            {priceFormat(current_nav)}&nbsp;&nbsp;
            <span className={navChange >= 0 ? "positive" : "negative"}>
              ({numberFormat(navChange)}%)
            </span>
            &nbsp;
          </p>
        </div>
        <p className="name">
          {scheme_name}
        </p>
        <p className="category">
          {category}
        </p>
      </div>
      <div className="mfwc-config">
        <div className="mfwc-config-row">
          <p>
            Inv. Cost (Avg. Cost)
            <span>{priceFormat(investment_cost)}({priceFormat(avg_cost)})</span>
          </p>
          <p>
            Inv. Value
            <span>{priceFormat(investment_value)}</span>
          </p>
        </div>
        <div className="mfwc-config-row">
          <p>
            Profit/Loss
            <span className={`${profit_loss >= 0 ? "positive" : "negative"}`}>{priceFormat(profit_loss)}</span>
          </p>
          <p>
            Units
            <span>{numberFormat(units)}</span>
          </p>
        </div>
        <div className="mfwc-config-row">
          <p>
            Total Return
            <span className={`${total_return >= 0 ? "positive" : "negative"}`}>
              {numberFormat(total_return)}%
            </span>
          </p>
          <p>
            XIRR
            <span className={`${xirr >= 0 ? "positive" : "negative"}`}>
              {numberFormat(xirr)}%
            </span>
          </p>
        </div>
      </div>
      {/* <div className="mfwc-buttons">
        <div
          className="hover-btn hover-input-btn"
          onClick={() => {
          }}
        >
          <img src="/static/media/select-graph.4c225a2b.svg" alt="hoverbutton" width={"20px"} height={"10px"} />
        </div>
        <div
          className="hover-btn hover-input-btn"
          onClick={() => {
            handleBuy(data);
          }}
        >
          Buy
        </div>
        <div
          className="hover-btn hover-cancel-btn"
          onClick={() => {
            handleSell(data);
          }}
        >
          Sell
        </div>
      </div> */}
    </div>
  );
}



export default FamilyPortfolioTable
